module.exports = __webpack_public_path__ + "img/hero_tab.5ba7923.webp";